import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { filter, debounceTime } from 'rxjs';
import { UserData } from 'src/app/models/userData.model';
import { CartService } from 'src/app/services/cart.service';
import { CommonService } from 'src/app/services/common.service';
import { EcatalogService } from 'src/app/services/ecatalog.service';
import { LoginService } from 'src/app/services/login.service';
import { Px2RemService } from 'src/app/services/px2-rem.service';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.less']
})
export class ProductDetailComponent implements OnInit {

  thumbnailImages: string[] = ['path_to_thumbnail_image_1', 'path_to_thumbnail_image_2', 'path_to_thumbnail_image_3']; // 缩略图路径数组
  isModalVisible: boolean = false;
  modalImage: string = '';
  isVehicleVisible: boolean = false;
  activeTab:string="oeNumber";
  carType:number=1;
  mobileCarType:number | string = 1;
  currentIndex: number = 0;
  visibleImages: any[] =[];
  itemWidth: number = 80; //img Width
  articleNumber:string="";
  partId:string="";
  productInfo: any={};
  mfrNameMap:any;
  mfrNameOptions:any;
  mergedCriteria:any;
  debounceTimer: any = null;
  imgUrl:any;
  vehicles:any[]=[];
  userData:UserData | undefined;
  isLogin:boolean=false;
  brand:any='';
  isVisible:boolean=false;
  country: string | null = localStorage.getItem("country");
  isScrollBottom: boolean = false;
  constructor(private translate:TranslateService,private loginService:LoginService,private commonService:CommonService,private elRef: ElementRef,public ecatalogService:EcatalogService,private message:NzMessageService,private cartService:CartService,private px2RemService:Px2RemService,private router: Router,private route:ActivatedRoute) { }
  showModal(image: string): void {
    this.modalImage = image;
    this.isModalVisible = true;
  }

    //switching sorting methods
    onCarTypeChange(event: any): void {
      this.mobileCarType = event;
      this.carType = event;
    }
    updateVisibleImages() {
      this.visibleImages = this.productInfo?.images.slice(this.currentIndex, this.currentIndex + 5);
    }
    scrollLeft() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.updateVisibleImages();
      }
    }
  
    scrollRight() {
      if (this.currentIndex < this.productInfo?.images.length - 5) {
        this.currentIndex++;
        this.updateVisibleImages();
      }
    }
  scrollToAnchor(anchor: string) {
    this.activeTab = anchor;
    const element = this.elRef.nativeElement.querySelector(`#${anchor}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center'});
    }
  }
  showDetail(brand:any):void{
    this.brand = brand;
    this.isVehicleVisible=true;
  }
  disabledDate = (current: Date): boolean => {
    if (this.isAutoPlusSevenNeed()) {
      const targetDate = new Date();
      targetDate.setDate(targetDate.getDate() + 7);
      targetDate.setHours(0, 0, 0, 0);
      return current < targetDate; // disable the date before today
    } else {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return current < today; // disable the date before today
    }
  };

  isAutoPlusSevenNeed() {
    const storedCustomer = localStorage.getItem("customer");
    const customerInfo = storedCustomer ? JSON.parse(storedCustomer) : null;
    const salesOrg = this.getOrgCode();
    if (customerInfo !== null && salesOrg === 'CN20-G4-40') {
      return true;
    } else {
      return false;
    }
  }

  getOrgCode(): string {

    const orgs = ["/iam", "/oes"];
    const router = orgs.find(org => window.location.pathname.includes(org));
    const orgMapping = JSON.parse(localStorage.getItem('allOrgRoutes') || '{}');
    const userOrg = JSON.parse(localStorage.getItem('sales_org') || '[]');
    const orgList = orgMapping[`${router}`];
    if (window.location.href.includes("Salesportal/iam/cart/gettoken")) {
      return 'CN20-G1-40';
    }
    if (!orgList || orgList.length === 0) {
      return '';
    }
    if (orgList.includes('CN20-G1-40') && userOrg.includes('CN20-G1-40')) {
      return 'CN20-G1-40';
    }

    const firstMatchingOrg = orgList.find((org: any) => userOrg.includes(org));

    return firstMatchingOrg ? firstMatchingOrg : orgList[0];
  }

  handleCancel(): void {
    this.isModalVisible = false;
  }
  async addToCart(product:any):Promise<void>{
    let params = {
      expectedDate: this.commonService.formatDateString(product.expectedDate),
      quantity: product.quantity,
      inputMaterialNumber: product.articleNumber
    }
    await this.cartService.addToCart([params]).then(()=>{
      this.message.create('success', this.translate.instant('ADD_TO_CART_SUCCESSFULLY'));
    });
  }

  goSearch(articleNumber:string,partId?:string):void{
    const country = localStorage.getItem("country");
    this.router.navigate([`${country}/product/detail`], {
      queryParams: { articleNumber: articleNumber, partId: partId }
    });
  }
  
  minusQuantity(product:any): void {
    if (product.minumQty === 0) {
      product.minumQty = 1; 
     }
    if (product.minumQty && product.quantity > product.minumQty) {
      product.quantity=product.quantity - product.minumQty;
    }
  }
  chooseDate(product:any):void{
    const oneWeekLater = moment().add(7, 'days');
    product.expectedDate =oneWeekLater.format('YYYY-MM-DD');
  }

  addQuantity(product:any): void {
   if (product.minumQty === 0) {
    product.minumQty = 1; 
   }
  if (product.minumQty && product.quantity) {
    product.quantity = product.quantity + product.minumQty;
  }
  }

  ngOnInit(): void {
    localStorage.setItem('isProductDetailBack','true');
    this.router.events.pipe(
      filter((event:any) => event instanceof NavigationEnd)
    ).subscribe(() => {
      window.scrollTo(0, 0);
    });
    this.route.queryParams.subscribe((params:any)=>{
      this.articleNumber = params['articleNumber'];
      this.partId = params['partId'];
      this.getArticleDetails();
    })
    this.loginService.userData$.subscribe((userData: any) => {
      this.userData = userData;
      this.isLogin=userData?.token?true:false;
    });
    window.addEventListener('scroll', ()=> {
      var scrollTop = document.documentElement.scrollTop;
      var clientHeight = document.documentElement.clientHeight;
      var scrollHeight = document.documentElement.scrollHeight;
      debounceTime(200);
      // 到底部了
      if(clientHeight + scrollTop >= scrollHeight - 200 ){
        this.isScrollBottom = true
      }else{
        this.isScrollBottom = false
      }
    });
    
  }
  getArticleDetails() {
   let params={query:this.partId};
    this.ecatalogService.queryArticleDetail(params).subscribe((result: any) => {
      let data =result.rtnData.articles;
      if(data.length>0){
        this.productInfo = data[0];
        this.productInfo.quantity= this.productInfo.minumQty===0?1:this.productInfo.minumQty;
        this.productInfo.expectedDate = this.ensureSevenDaysBuffer();
        this.queryArticleLinkedManufacturer2(this.productInfo.genericArticles[0].legacyArticleId);
        this.activeTab = this.productInfo.oemNumbers?.length>0?'oeNumber':'criteria';
        const mfrNameMap: { [key: string]: any[] } = {};
        this.productInfo.oemNumbers?.forEach((item:any) => {
            if (!mfrNameMap[item.mfrName]) {
                mfrNameMap[item.mfrName] = [];
            }
            mfrNameMap[item.mfrName].push(item);
        });
        this.mfrNameMap = mfrNameMap;
        this.mfrNameOptions = Object.keys(mfrNameMap);
        this.carType = this.mfrNameOptions?.[0] || '';
        this.mobileCarType = "";
        this.imgUrl = this.productInfo.images?.[0].imageURL800 || '';
        this.mergedCriteria = this.productInfo.articleCriteria.reduce((acc:any, curr:any) => {
          const existingCriteria = acc.find((item:any) => item.criteriaAbbrDescription === curr.criteriaAbbrDescription);
          if (existingCriteria) {
              existingCriteria.formattedValue += `, ${curr.formattedValue}`;
          } else {
            if(curr.criteriaAbbrDescription){
              acc.push(curr);
            }
              
          }
          return acc;
      }, []);
      }
      });
  }

  ensureSevenDaysBuffer() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const minDate = new Date(today);
    minDate.setDate(today.getDate() + 7);
    if (this.isAutoPlusSevenNeed()) {
      return minDate;
    }
    return today;
  }

  quantityBlur(newQuantity: number) {
    this.productInfo.quantity = newQuantity;
  }
  quantityChange(newQuantity: number) {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.productInfo.quantity = newQuantity;
    }, 1000);
  }
  goPic(imgUrl:string){
    this.imgUrl = imgUrl;
  }
  // get vehicles data
  queryArticleLinkedManufacturer2(legacyArticleId:string) {
    let params={articleId:legacyArticleId};
    this.ecatalogService.queryArticleLinkedManufacturer2(params).subscribe((result: any) => {
      this.vehicles = result.rtnData;
    });
  }
  handleClose():void{
    this.isVehicleVisible = false;
  }
  backFromProductDetail(): void {
    const country = localStorage.getItem("country");
    const url = country?`${country}/ecatalog`:'/ecatalog';
    this.router.navigateByUrl(url);
  }

}
